/**
 * NOTE: This JS is included on every page of avvoka, please be aware of what you put here.
 */

import {createPinia, setActivePinia} from "pinia";
import * as Vue from "vue"
import * as Vuex from "vuex"

import useDefaultTheme from '@library/themes/default.theme'
import useEditorTheme from '@library/themes/editor.theme'

setActivePinia(createPinia())

import "../channels/consumer"
import { createVueApp } from "~/features/vue";
import Utils from "~/features/utils";

window.Vue = Vue;
window.Vuex = Vuex;

/** RESERVED ONLY FOR DIRECT HTML USE */
window.createVueApp = createVueApp;
window.axios = Utils.axios;

useDefaultTheme('default')
useEditorTheme('editor')
